/**
 * Serialize logical file-index replace operations while allowing each short SQLite batch
 * to release the shared code-nav DB lock between chunks.
 */
let fileIndexChain: Promise<unknown> = Promise.resolve();

export function withFileIndexSqliteLock<T>(fn: () => T | Promise<T>): Promise<T> {
  const next = fileIndexChain.then(() => Promise.resolve(fn()));
  fileIndexChain = next.then(
    () => undefined,
    () => undefined,
  );
  return next;
}
